// Selectors
const DROPDOWN_SELECTOR = '.js-dropdown';
const SELECTED_OPTION_SELECTOR = '.js-dropdown-selected-option';
const ARROW_SELECTOR = '.js-dropdown-arrow';
const OPTIONS_CONTAINER_SELECTOR = '.js-dropdown-body';
const OPTION_PREVIEW_CONTAINER_SELECTOR = '.js-dropdown-label';
const INPUT_SELECTOR = '.js-dropdown-input';

// Attributes
const OPTION_VALUE_ATTR = 'data-dropdown-option-value';
const DROPDOWN_ACTIVITY_ATTR = 'data-dropdown-active';
const UI_CLASSES_PREFIX_ATTR = 'data-dropdown-ui-prefix';


// Classes
const INNER_TRIGGER_CLASS = 'js-dropdown-inner-trigger';
const OPTION_CLASS = 'js-dropdown-option';
const PLACEHOLDER_CLASS = 'js-dropdown-placeholder';

// Ui classes particles
const DEFAULT_UI_PREFIX = 'ui-dropdown';

const UI_OPTIONS_CONTAINER_ACTIVE_PARTICLE = '__body_active';
const UI_OPTIONS_CONTAINER_INACTIVE_PARTICLE = '__body_inactive';
const UI_TRIGGER_ACTIVE_PARTICLE = '__trigger_active';
const UI_TRIGGER_SELECTED_PARTICLE = '__trigger_selected';
const UI_ARROW_ACTIVE_PARTICLE = '__arrow_active';


// Run code


function setUp() {
    bindEvents();

    var dropdowns = document.querySelectorAll(DROPDOWN_SELECTOR);
    dropdowns.forEach(function (dropdown) {
        var option = dropdown.querySelector(`.${OPTION_CLASS}`);
        // Set first option as selected one
        if (option) selectNewOption(dropdown, option);

        dropdown.setOption = function (option) {
            selectNewOption(this, option);
        }

    });
}

setUp();


// Functions
function bindEvents() {
    document.addEventListener('click', function (event) {
        toggleDropdownOnClick(event.target);
        selectOptionOnClick(event.target);
    });
}


function selectOptionOnClick(target) {
    var selectOption = target.classList.contains(OPTION_CLASS) ? target : target.closest(`.${OPTION_CLASS}`);

    if (selectOption) {
        let dropdown = selectOption.closest(DROPDOWN_SELECTOR);
        if (!dropdown) throw new Error(`No ${DROPDOWN_SELECTOR} correlating to ${selectOption}`);

        selectNewOption(dropdown, selectOption);
        close(dropdown);
    }
}


function toggleDropdownOnClick(target) {
    var innerTriggerElement
     = target.classList.contains(INNER_TRIGGER_CLASS) ? target : target.closest(`.${INNER_TRIGGER_CLASS}`);

    if (innerTriggerElement) {
        let dropdown = innerTriggerElement.closest(DROPDOWN_SELECTOR);
        if (!dropdown) throw new Error(`No ${DROPDOWN_SELECTOR} correlating to ${innerTriggerElement}`);

        if (isClosed(dropdown)) closeAllOpenedDropdowns();

        switchDropdown(dropdown);
    } else {
        let isClickInsideDropdown = target.closest(DROPDOWN_SELECTOR);
        if (!isClickInsideDropdown) closeAllOpenedDropdowns();
    }
}



function switchDropdown(dropdown) {
    if (isClosed(dropdown)) return open(dropdown);
    return close(dropdown);
}


function selectNewOption(dropdown, option) {
    setValueOnInput(dropdown, option);
    updateViewOfSelectedOption(dropdown, option);
}


function open(dropdown) {
    dropdown.setAttribute(DROPDOWN_ACTIVITY_ATTR, 1);
    toggleDropdownOptions(dropdown);
    toggleDropdownClasses(dropdown);
}


function close(dropdown) {
    dropdown.removeAttribute(DROPDOWN_ACTIVITY_ATTR);
    toggleDropdownOptions(dropdown);
    toggleDropdownClasses(dropdown);
}


function closeAllOpenedDropdowns() {
    var openedDropdowns = getOpenedDropdowns();
    openedDropdowns.forEach(dropdown => close(dropdown));
}


function isOpened(dropdown) {
    return dropdown.hasAttribute(DROPDOWN_ACTIVITY_ATTR);
}


function isClosed(dropdown) {
    return !isOpened(dropdown);
}


function setValueOnInput(dropdown, option) {
    if (!option.hasAttribute(OPTION_VALUE_ATTR)) {
        throw new Error(`Each option must have a value specified in ${OPTION_VALUE_ATTR}`);
    }
    var optionValue = option.getAttribute(OPTION_VALUE_ATTR);

    var valueHolderInput = dropdown.querySelector(INPUT_SELECTOR);
    if (!valueHolderInput) {
        throw new Error(`The dropdown should have hidden field ${INPUT_SELECTOR} which would contain value.`);
    }


    if (String(valueHolderInput.value) !== String(optionValue)) {
        valueHolderInput.value = optionValue;

        event = document.createEvent("HTMLEvents");
        event.initEvent("change", true, true);
        event.eventName = "change";
        valueHolderInput.dispatchEvent(event);
    }
}


function updateViewOfSelectedOption(dropdown, option) {
    var placeForDisplayingSelectedOption = dropdown.querySelector(SELECTED_OPTION_SELECTOR);
    if (!placeForDisplayingSelectedOption) {
        throw new Error(`No ${SELECTED_OPTION_SELECTOR} specified at dropdown!`);
    }

    var labelContent = option.querySelector(OPTION_PREVIEW_CONTAINER_SELECTOR);

    if (labelContent) {
        placeForDisplayingSelectedOption.innerHTML = labelContent.innerHTML;
    } else {
        placeForDisplayingSelectedOption.innerHTML = option.innerHTML;
    }


    var trigger = dropdown.querySelector(`.${INNER_TRIGGER_CLASS}`);
    if (!option.classList.contains(PLACEHOLDER_CLASS)) {
        trigger.classList.add(uiTriggerSelectedClass(dropdown));
    } else {
        trigger.classList.remove(uiTriggerSelectedClass(dropdown));
    }
}


function toggleDropdownOptions(dropdown) {
    var dropdownOptionsContainer = dropdown.querySelector(OPTIONS_CONTAINER_SELECTOR);
    if (!dropdownOptionsContainer) {
        throw new Error(`Dropdown options container is not found in ${dropdown}. Specify ${OPTIONS_CONTAINER_SELECTOR}`);
    }

    if (isOpened(dropdown)) {
        dropdownOptionsContainer.classList.remove(uiOptionsContainerInactiveClass(dropdown));
        dropdownOptionsContainer.classList.add(uiOptionsContainerActiveClass(dropdown));
        return;
    }

    dropdownOptionsContainer.classList.add(uiOptionsContainerInactiveClass(dropdown));
    dropdownOptionsContainer.classList.remove(uiOptionsContainerActiveClass(dropdown));
}


function toggleDropdownClasses(dropdown) {
    var innerTrigger = dropdown.querySelector(`.${INNER_TRIGGER_CLASS}`);
    var dropdownArrow = dropdown.querySelector(ARROW_SELECTOR);

    if (isOpened(dropdown)) {

        if (innerTrigger) {
            innerTrigger.classList.add(uiTriggerActiveClass(dropdown));
            innerTrigger.classList.remove(uiTriggerSelectedClass(dropdown));
        }
        if (dropdownArrow) dropdownArrow.classList.add(uiArrowActiveClass(dropdown));

    } else {

        if (innerTrigger) innerTrigger.classList.remove(uiTriggerActiveClass(dropdown));
        if (dropdownArrow) dropdownArrow.classList.remove(uiArrowActiveClass(dropdown));

    }
}


function getOpenedDropdowns() {
    return document.querySelectorAll(`${DROPDOWN_SELECTOR}[${DROPDOWN_ACTIVITY_ATTR}]`);
}



// Ui classes
function uiArrowActiveClass(dropdown) {
    return uiClass(dropdown, UI_ARROW_ACTIVE_PARTICLE);
}

function uiTriggerActiveClass(dropdown) {
    return uiClass(dropdown, UI_TRIGGER_ACTIVE_PARTICLE);
}

function uiTriggerSelectedClass(dropdown) {
    return uiClass(dropdown, UI_TRIGGER_SELECTED_PARTICLE);
}

function uiOptionsContainerActiveClass(dropdown) {
    return uiClass(dropdown, UI_OPTIONS_CONTAINER_ACTIVE_PARTICLE);
}

function uiOptionsContainerInactiveClass(dropdown) {
    return uiClass(dropdown, UI_OPTIONS_CONTAINER_INACTIVE_PARTICLE);
}


function uiClass(dropdown, particle) {
    var prefix = dropdown.getAttribute(UI_CLASSES_PREFIX_ATTR);
    if (!prefix) prefix = DEFAULT_UI_PREFIX;
    return prefix+particle;
}

// // //
// Multi Select Initialization
/*$(function () {

    var _custom_select = $('.select-js');
    _custom_select.selectpicker({
        // sanitize: false,
        // showContent: false,
        // sanitizeFn: function (domNodes) {
        //     return domNodes;
        // }
    });
    _custom_select.each(function () {
        this.addEventListener('cs.update', function (e) {
            $(this).selectpicker('refresh');
        });
        this.addEventListener('cs.toggle', function (e) {
            $(this).selectpicker('toggle');
        });
    });

});*/

